import React, { useState } from "react";
import ImmoHeader from "../../immobilier/componnents/ImmoHeader";
import moment from "moment";
import { deepSearchFunction } from "../../../redux/actions/immobilierActions";
import { useDispatch } from "react-redux";
import { setActiveOnglet } from "../../../redux/actions/immobilierActions";
import { useNavigate } from "react-router-dom";

const SavedSearches = ({ savedSearches }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const handleSearch = (search) => {
    const searchData = {
      usage: search.usage,
      lieu: search.lieu,
      dispositif: search.dispositif,
      zoneFiscale: search.zoneFiscale,
      statutLot: search.statutLot,
      dateDajout: search.dateDajout,
      natureMandat: search.natureMandat,
      budgetMin: search.budgetMin,
      budgetMax: search.budgetMax,
      prixM2Min: search.prixM2Min,
      prixM2Max: search.prixM2Max,
      rentabilite: search.rentabilite,
      honoraires: search.honoraires,
      referenceLot: search.referenceLot,
      nature: search.nature,
      surfaceMin: search.surfaceMin,
      surfaceMax: search.surfaceMax,
      espaceTotalMin: search.espaceTotalMin,
      espaceTotalMax: search.espaceTotalMax,
      typologieLot: search.typologieLot,
      etage: search.etage,
      annexe: search.annexe,
      programmeParent: search.programmeParent,
      promoteur: search.promoteur,
      dateDajoutProgramme: search.dateDajoutProgramme,
      tag: search.tag,
      label: search.label,
      lotMaximum: search.lotMaximum,
    };

    dispatch(deepSearchFunction(searchData));
    dispatch(setActiveOnglet("searchResults"));
    navigate("/immobilier");
  };

  const [searchFilter, setSearchFilter] = useState("");
  return (
    <div>
      <ImmoHeader
        carte={false}
        lots={false}
        programmes={false}
        filterInput={searchFilter}
        setFilterInput={setSearchFilter}
      />
      {/* Header */}
      <div className="table-searches-prog-header pink text-center mt-10 mb-10 ">
        <div className="table-cell">Date de la recherche</div>
        <div className="table-cell">Lieu</div>
        <div className="table-cell">Budget (min-max)</div>
        <div className="table-cell">Surface (min-max)</div>
        <div className="table-cell">Typologies</div>
      </div>
      {/* Rows */}
      <div className="d-flex flex-column gap10 ">
        {savedSearches.length > 0 ? (
          savedSearches
            .filter((search) => {
              return search?.lieu
                ?.toLowerCase()
                .includes(searchFilter?.toLowerCase());
            })
            .map((search) => (
              <div
                key={search.id}
                className=" tables-rows-searches-prog saved-searches-row"
                onClick={() => handleSearch(search)}
                style={{ cursor: "pointer" }}
              >
                <div className="text-center ">
                  <div>{moment(search.createdAt).format("DD/MM/YYYY")}</div>
                </div>
                <div className="text-center ">
                  <div>{search.lieu || "Non mentionné"}</div>
                </div>
                <div className="text-center ">
                  <div>
                    {search.budgetMin
                      ? `${search.budgetMin} €`
                      : "Non mentionné"}{" "}
                    -{" "}
                    {search.budgetMax
                      ? `${search.budgetMax} €`
                      : "Non mentionné"}
                  </div>
                </div>
                <div className="text-center ">
                  <div>
                    {search.surfaceMin || "Non mentionné"} -{" "}
                    {search.surfaceMax || "Non mentionné"}
                  </div>
                </div>
                <div className="text-center ">
                  <div>{search.typologieLot || "Non mentionné"}</div>
                </div>
              </div>
            ))
        ) : (
          <div className="text-center">Aucune recherche enregistrée</div>
        )}
      </div>
    </div>
  );
};

export default SavedSearches;
